








































import { Component, Vue } from "vue-property-decorator"
import moment from 'moment'

import RunStep from './RunStep.vue'
import Run from './Run.vue'

@Component({
    components: {
        RunStep,
        Run
    }
})
export default class Home extends Vue{
    steps = [{"type":"CHRONO","chrono":{"min":5,"sec":0},"text":"105 - 120"},{"type":"CHRONO","chrono":{"min":1,"sec":0},"text":"120 - 140"},{"type":"CHRONO","chrono":{"min":1,"sec":0},"text":"140 - 155"},{"type":"CHRONO","chrono":{"min":1,"sec":0},"text":"120 - 140"},{"type":"CHRONO","chrono":{"min":2,"sec":0},"text":"105 - 120"},{"type":"CHRONO","chrono":{"min":10,"sec":0},"text":"120 - 140"},{"type":"PAUSE","chrono":{"min":0,"sec":0},"text":"110"},{"type":"CHRONO","chrono":{"min":4,"sec":0},"text":"140 - 155"},{"type":"PAUSE","chrono":{"min":0,"sec":0},"text":"110"},{"type":"CHRONO","chrono":{"min":1,"sec":0},"text":"150"},{"type":"PAUSE","chrono":{"min":0,"sec":0},"text":"110"},{"type":"CHRONO","chrono":{"min":10,"sec":0},"text":"120 - 140"},{"type":"PAUSE","chrono":{"min":0,"sec":0},"text":"110"},{"type":"CHRONO","chrono":{"min":4,"sec":0},"text":"140 - 155"},{"type":"PAUSE","chrono":{"min":0,"sec":0},"text":"110"},{"type":"CHRONO","chrono":{"min":1,"sec":0},"text":"150"},{"type":"CHRONO","chrono":{"min":5,"sec":0},"text":"105 - 120"}]

    dialogPlay = false

    addStep() {
        this.steps.push({
            type: "CHRONO",
            chrono: {
                min: 0,
                sec: 0
            },
            text: "",
        })
    }

    deleteStep(index: any) {
        this.steps.splice(index, 1)
    }

    test() {
        console.log(JSON.stringify(this.steps))
    }
}
